import { createCommand } from "lexical";

export const ADD_EMOJI_COMMAND = createCommand('ADD_EMOJI_COMMAND');
